import { th, variants, zIndexes } from 'style/theme';
import styled, { css } from 'styled-components';
import NILogo from 'products/nomad_insurance/assets/img/logos/nomad-insurance-black.svg';
import { FaCaretDown } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { GLOBAL_NAV_HEIGHT } from 'consts';
import Button from '../../Button';

export const ProductNavbar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: fixed;
  align-items: center;
  top: 0px;
  left: 0;
  height: 55px;
  background: ${th('colors.white')};
  border-radius: 0 0 8px 8px;
  padding-left: 15px;
  transition: 0.2s;
  z-index: ${zIndexes.navigation};
`;

export const Logo = styled.div`
  cursor: pointer;
  background-image: url(${NILogo});
  transition: 0.2s;
  background-size: cover;
  width: 175px;
  height: 36px;
`;

export const Caret = styled(FaCaretDown)`
  font-size: 26px;
  color: ${th('colors.black')};
  transition: 0.2s;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `};
`;

export const Dropdown = styled.div`
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 60px;
  cursor: pointer;
`;

export const AppButton = styled(Button)`
  padding: 6px 12px;
  margin-left: auto;
  font-size: 14px;
`;

export const MenuContainer = styled.div`
  -webkit-tap-highlight-color: transparent;
  position: absolute;
  top: 48px;
  left: 0;
  display: block;
  width: 100%;
  /* 48px is used for product navbar height since this is attached at top: 48px */
  height: calc(100vh - 48px - ${GLOBAL_NAV_HEIGHT}px);
  max-height: ${({ isOpen }) =>
    isOpen ? `calc(100vh - 48px - ${GLOBAL_NAV_HEIGHT}px)` : '0px'};
  border-radius: ${({ isOpen }) => (isOpen ? `0` : '0 0 8px 8px')};
  will-change: height;
  transition: margin-top 0.2s, max-height 0.15s ease-in-out;
  z-index: ${zIndexes.navigation - 1};
  background: ${th('colors.white')};
  color: ${th('colors.pickledBluewood')};
  overflow-y: scroll;

  > button {
    margin-bottom: 8px;
    margin-top: 15px;
  }
`;

export const SpaceBetweenContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  padding-top: 16px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Header = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const Link = styled(NavLink).attrs({ exact: true })`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  border-radius: 16px;
  position: relative;
  text-decoration: none;
  padding: 12px 16px;

  color: ${th('colors.pickledBluewood')};
  transition: 0.2s;

  font-weight: 700;
  font-size: 16px;

  > svg {
    width: 24px;
  }

  > svg,
  > svg > path {
    fill: ${th('colors.pickledBluewood')};
  }

  &.active {
    color: ${th('colors.white')};
    > svg {
      fill: ${th('colors.white')};
    }
    background-color: ${th('colors.fountainBlue')};
  }

  ${variants('variant', {
    myInsurance: css`
      &.active {
        background-color: ${th('colors.fountainBlue')};
      }
    `,
    claims: css`
      &.active {
        background-color: ${th('colors.orange')};
      }
    `,
    receipts: css`
      &.active {
        background-color: ${th('colors.yellow')};
      }
    `,
    myProfile: css`
      &.active {
        background-color: ${th('colors.blue')};
      }
    `
  })}
`;

export const ItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  border-radius: 16px;
  background-color: ${th('colors.fountainBlue+4')};
  margin-bottom: 16px;
`;
